import { createContext, useContext } from 'react';
import type { ShowToast } from './types';

// The context value type is centralized in `src/types` (see `./types/ui`);
// re-exported here so existing `import { ShowToast } from './ToastContext'`
// call sites keep resolving.
export type { ShowToast };

export const ToastContext = createContext<ShowToast | null>(null);

export const useToast = (): ShowToast => {
  const toast = useContext(ToastContext);

  if (toast === null) {
    throw new Error('useToast must be used within a ToastContext.Provider');
  }

  return toast;
};
